import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import "./LoginForm.css";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { useAuth } from "../common/AuthContext";
import { environment } from "environment/environment";

export default function LoginForm() {
  const navigate = useNavigate();
  const { login, refreshUserPlan } = useAuth();

  const [form, setForm] = useState({ email: "", password: "" });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  // 🔹 Input handler
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  // 🔹 Validation
  const validate = () => {
    const newErrors = {};
    if (!form.email.trim()) newErrors.email = "Email is required";
    else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(form.email)
    )
      newErrors.email = "Invalid email address";

    if (!form.password) newErrors.password = "Password is required";
    else if (form.password.length < 6)
      newErrors.password = "Password must be at least 6 characters";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // 🔹 Login handler
  const handleLogin = async (e) => {
    e.preventDefault();

    if (!validate()) {
      toast.error("Please check your input.");
      return;
    }

    setLoading(true);

    try {
      const response = await axios.post(
        `${environment.baseUrl}/user/login`,
        form
      );

      const data = response.data;

      if (response.status === 200 && data?.data) {
        login(data.data);
        const plan = await refreshUserPlan(data.data.userId);

        toast.success(data.message || "Login successful!", {
          autoClose: 1500,
          onClose: () => {
            setLoading(false);

            if (plan) navigate("/nse-option-chain");
            else navigate("/subscribe");
          },
        });
      } else {
        setLoading(false);
        toast.error(data.message || "Invalid credentials.");
      }
    } catch (error) {
      setLoading(false);
      toast.error(
        error.response?.data?.message || "Login failed. Try again."
      );
    }
  };

  return (
    <div className="login-container">
      <form className="login-form card shadow-sm" onSubmit={handleLogin} noValidate>
        <h2 className="text-center mb-4">Login</h2>

        {/* Email */}
        <div className="mb-3">
          <label className="form-label">Email</label>
          <input
            type="email"
            name="email"
            className={`form-control ${errors.email ? "is-invalid" : ""}`}
            value={form.email}
            onChange={handleChange}
          />
          {errors.email && (
            <div className="invalid-feedback">{errors.email}</div>
          )}
        </div>

        {/* Password */}
        <div className="mb-3">
          <label className="form-label">Password</label>
          <input
            type="password"
            name="password"
            className={`form-control ${errors.password ? "is-invalid" : ""}`}
            value={form.password}
            onChange={handleChange}
          />
          {errors.password && (
            <div className="invalid-feedback">{errors.password}</div>
          )}
        </div>

        {/* 🔥 Spinner Button */}
        <button
          type="submit"
          className="btn btn-primary w-100 d-flex justify-content-center align-items-center"
          disabled={loading}
        >
          {loading ? (
            <>
              <span
                className="spinner-border spinner-border-sm me-2"
                role="status"
                aria-hidden="true"
              ></span>
              Logging in...
            </>
          ) : (
            "Login"
          )}
        </button>

        {/* Links */}
        <p className="text-center mt-3">
          Don’t have an account? <Link to="/signup">Sign Up</Link>
        </p>
        <p className="text-center">
          Forgot Password? <Link to="/forgot-password">Click here</Link>
        </p>
      </form>

      <ToastContainer position="top-center" autoClose={2000} />
    </div>
  );
}
